import { AllAccountsByCustomerType } from 'features/registration/components/extra-address-modal/types'
import { CUSTOMER_TYPES } from '@boltenergy-be/shared'

export const EMPTY_ACCOUNTS_BY_CUSTOMER_TYPE: AllAccountsByCustomerType = {
  [CUSTOMER_TYPES.residential]: [],
  [CUSTOMER_TYPES.professional]: []
}
